import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { AlertService } from '@app/alert/service/alert.service'
import { ArquivoModel } from '@shared/models/backend'
import { take } from 'rxjs/operators'

const BROKEN_LINK_MESSAGE = 'Não é possível recuperar este documento pois ele não está mais disponível para download'

@Injectable({
  providedIn: 'root',
})
export class FileDownloaderService {
  constructor(private alertService: AlertService, private httpClient: HttpClient) {}

  showAlertBrokenLink() {
    this.alertService.showError(BROKEN_LINK_MESSAGE)
  }

  getDownloadLink(arquivo: ArquivoModel) {
    if (!arquivo) {
      return ''
    }
    const { hash, id } = arquivo
    return `api/arquivos/${id}?hash=${hash}`
  }

  private getVerifyLink(downloadLink: string) {
    return `${downloadLink}&verifyOnly=true`
  }

  download(arquivo: ArquivoModel) {
    const downloadLink = this.getDownloadLink(arquivo)
    this.httpClient
      .get(this.getVerifyLink(downloadLink))
      .pipe(take(1))
      .subscribe(
        (_) => {
          window.location.href = downloadLink
        },
        (_) => {
          this.showAlertBrokenLink()
        }
      )
  }
}
